import HintItem from '../HintItem';

export default class ButtonHelp extends Phaser.Group {
  constructor(game, state) {
    super(game);

    this.state = state;

    this.onSelect = new Phaser.Signal();
    this.isDown = true;

    this.asset = this.game.make.spine(0, 0, 'spine_help_button', true);
    this.asset.anchor.set(0.5, 1);
    this.addChild(this.asset);
    this.asset.setAnimationByName(0, 'down', false);

    this.rootBone = this.asset.skeleton.getRootBone();

    this.button = this.game.make.button(0, 0, 'empty');
    this.button.width = 80;
    this.button.height = 80;
    this.button.anchor.set(0.5, 1);
    this.addChild(this.button);
    this.button.events.onInputDown.add(this.handleInputDown, this);

    // scale for tablet
    this.scaleDef = 1;
    if (this.game.deviceMetric.platform.type === 'smartphone') {
      this.scaleDef = 1.2;
      this.rootBone.scaleX = this.scaleDef;
      this.rootBone.scaleY = this.scaleDef;
    }
  }

  enable() {
    this.button.input.enabled = true;
  }

  disable() {
    this.button.input.enabled = false;
  }

  handleInputDown() {
    if (this.isDown) {
      this.isDown = false;
      this.button.visible = false;

      if (this.timeEvent) {
        this.game.time.events.remove(this.timeEvent);
        this.timeEvent = null;
      } else {
        this.asset.setAnimationByName(0, 'go_up', false);
      }

      this.onSelect.dispatch();

      // hide button
      // this.game.time.events.add(200, this.hide, this);
    }
  }

  hide() {
    if (!this.isDown) {
      this.asset.onComplete.addOnce(this.handleAnimDownComplete, this);
      this.asset.setAnimationByName(0, 'go_down', false);

      //
      if (this.hintData) {
        this.hintData = null;
        const len = this.hintItems.length;
        for (let i = 0; i < len; i++) {
          this.hintItems[i] && this.hintItems[i].hide();
        }
        this.hintItems = null;
      }
    }
  }

  handleAnimDownComplete() {
    this.isDown = true;
    this.button.visible = true;
  }

  pulse(time = 2500) {
    this.asset.setAnimationByName(0, 'go_up', false);

    const s0 = 1 * this.scaleDef;
    const s1 = 1.2 * this.scaleDef;
    //
    this.game.add
      .tween(this.rootBone)
      .to({ scaleX: [s1, s0, s1, s0, s1, s0], scaleY: [s1, s0, s1, s0, s1, s0] }, time, null, true)
      .onComplete.addOnce(this.onCompletePulse, this);
  }

  onCompletePulse() {
    this.asset.setAnimationByName(0, 'go_down', false);
  }

  // used for loop hints
  growUp() {
    if (this.timeEvent) {
      this.game.time.events.remove(this.timeEvent);
    } else {
      this.asset.setAnimationByName(0, 'go_up2', false);
    }

    const s0 = 1 * this.scaleDef;
    const s1 = 1.2 * this.scaleDef;

    this.game.add
      .tween(this.rootBone)
      .to(
        { scaleX: [s1, s0, s1, s0, s1, s0, s1, s0], scaleY: [s1, s0, s1, s0, s1, s0, s1, s0] },
        3000,
        null,
        true
      );

    this.timeEvent = this.game.time.events.add(5000, this.shrink, this);
  }

  shrink() {
    this.timeEvent = null;
    this.state.removeLoopHint();
    this.asset.setAnimationByName(0, 'go_down2', false);
  }

  // circles for example_hint
  showExample(data, duration) {
    //  { "items": ["bread_slice", "banana_unpeeled"], "result": "sandwich_banana" },
    // create items
    this.hintData = data;
    this.hintItems = [];
    const len = data.items.length;
    const size = len === 3 ? 0.7 : 1;
    const angle0 = len === 3 ? 0 : -20;
    const da = len === 3 ? -45 : -60;
    for (let i = 0; i < len; i++) {
      const item = new HintItem(this.game, data.items[i], angle0 + da * i, size);
      item.y = -40;
      item.show();
      this.hintItems.push(item);
      this.addChildAt(item, 0);
    }

    //
    if (data.result) {
      this.game.time.events.add(duration * 0.5, this.combineItems, this);
    }
  }

  combineItems() {
    const len = this.hintItems.length;
    for (let i = 0; i < len; i++) {
      this.hintItems[i].rotateTo(-45);
    }
    this.game.time.events.add(250, this.showNewItem, this);
  }

  showNewItem() {
    const len = this.hintItems.length;
    // remove other items and leave only 1st
    for (let i = 1; i < len; i++) {
      this.hintItems[i].destroy();
      this.hintItems[i] = null;
    }
    this.hintItems[0].showNewItem(this.hintData.result);
  }
}
